import { memo } from 'react';
import { ensureArray } from '../../utils';
import { OptionTag } from '../option-tag';
import * as Styled from './styles';
import type { TagWrapperProps as Props } from './types';

export const TagWrapper = memo(
  ({ className, getTagProps, multiple, value, onDelete }: Props) => {
    return (
      <Styled.Wrapper>
        {multiple ? (
          (value as any[]).map((option, index: number) => {
            const prop = getTagProps({ index });
            return (
              <OptionTag
                multiple
                key={`${option.value}-${index}`}
                label={option.label}
                logoUrl={option.logo}
                onDelete={prop.onDelete}
                extraDeleteAction={() =>
                  onDelete?.(option, ensureArray(value as any[]))
                }
              />
            );
          })
        ) : (
          <OptionTag
            key={(value as any).value}
            label={(value as any).label}
            extraDeleteAction={() =>
              onDelete?.(value as any, ensureArray(value as any[]))
            }
          />
        )}
      </Styled.Wrapper>
    );
  }
);

TagWrapper.displayName = 'TagWrapper';
